import { useMutation } from '@tanstack/react-query';

import { getExtranetApi } from '../extranetApi';

/** `POST /v1/invitation/:invitationId/resend` — renvoie l'email d'une invitation en attente (204). */
export const useResendInvitation = () =>
  useMutation({
    mutationFn: (invitationId: string) =>
      getExtranetApi().post<undefined, void>(`/v1/invitation/${encodeURIComponent(invitationId)}/resend`, undefined),
  });
